import { Box, Typography } from "@mui/material";
import { createFileRoute, useParams } from "@tanstack/react-router";

import { useHydratedConnector } from "@/api/connectors/index";
import { LoadingFallback } from "@/components/LoadingFallback";
import { ConnectorConfigPage } from "@/features/Connectors/ConnectorConfigPage";

export const Route = createFileRoute(
  "/_auth/settings/$siteId/connectors/$connectorId",
)({
  component: ConnectorConfigRoute,
});

function ConnectorConfigRoute() {
  const { siteId = "", connectorId = "" } = useParams({
    from: "/_auth/settings/$siteId/connectors/$connectorId",
  });
  const {
    data: hydratedConnector = null,
    isLoading,
    isFetching,
    isError,
    error,
  } = useHydratedConnector(siteId, connectorId, {
    refetchOnMount: "always",
  });

  if (isLoading || isFetching) {
    return <LoadingFallback />;
  }

  if (isError) {
    return (
      <Box sx={{ py: 7 }}>
        <Typography variant="body2" color="error">
          {error instanceof Error
            ? error.message
            : "Failed to load connector details."}
        </Typography>
      </Box>
    );
  }

  if (!hydratedConnector) {
    return (
      <Box sx={{ py: 7 }}>
        <Typography variant="body2" color="text.secondary">
          Connector not found.
        </Typography>
      </Box>
    );
  }

  // A connector without a Dragon Tile (a data hub with no subscribable events)
  // is still configurable here; it just has no enable/disable state and no tile
  // to navigate to.
  const { tile } = hydratedConnector;

  return (
    <ConnectorConfigPage
      connector={hydratedConnector.installed}
      isEnabled={tile?.is_active ?? true}
      hasDragonTile={!!tile}
    />
  );
}
